export enum FontSize {
  xxl = 'var(--atira-font-size-heading-xl)',
  xl = 'var(--atira-font-size-heading)',
  l = 'var(--atira-font-size-sub-heading)',
  m = 'var(--atira-font-size-body)',
  s = 'var(--atira-font-size-small)',
  xs = 'var(--atira-font-size-note)',
}
